import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { caseInsensitiveMap1xhpwzg797p51 as caseInsensitiveMap } from './Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  Entry2xmjmyutzoq3p as Entry,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { unmodifiable2pi9okt3ceep6 as unmodifiable } from './Collections.web.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString336ienavfnzn0 as toString,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals_0,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function appendAll(_this__u8e3s4, builder) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = builder.o4p().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var name = element.m3();
    // Inline function 'kotlin.collections.component2' call
    var values = element.n3();
    _this__u8e3s4.p4p(name, values);
  }
  return _this__u8e3s4;
}
function ensureListForKey($this, name) {
  var tmp0_elvis_lhs = $this.r4p_1.x4(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList().p2();
    $this.s4p(name);
    // Inline function 'kotlin.collections.set' call
    $this.r4p_1.a5(name, this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var StringValuesBuilderImplClass;
function StringValuesBuilderImpl() {
  if (StringValuesBuilderImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, size) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        size = size === VOID ? 8 : size;
        this.q4p_1 = caseInsensitiveName;
        this.r4p_1 = this.q4p_1 ? caseInsensitiveMap() : LinkedHashMap().fc(size);
      }
      t4p() {
        return this.q4p_1;
      }
      u4p(name) {
        return this.r4p_1.x4(name);
      }
      o4o(name) {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.r4p_1;
        return (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).v4(name);
      }
      v4p() {
        return this.r4p_1.y4();
      }
      n1() {
        return this.r4p_1.n1();
      }
      o4p() {
        return unmodifiable(this.r4p_1.l3());
      }
      w4p(name, value) {
        this.x4p(value);
        var list = ensureListForKey(this, name);
        list.s4();
        list.j2(value);
      }
      d2o(name) {
        var tmp0_safe_receiver = this.u4p(name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      y4p(name, value) {
        this.x4p(value);
        ensureListForKey(this, name).j2(value);
      }
      z4p(stringValues) {
        stringValues.a4q((name, values) => {
          this.p4p(name, values);
          return Unit_instance;
        });
      }
      p4p(name, values) {
        // Inline function 'kotlin.let' call
        var list = ensureListForKey(this, name);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = values.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          this.x4p(element);
        }
        addAll(list, values);
      }
      b4q(name, values) {
        var tmp0_safe_receiver = this.r4p_1.x4(name);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toSet(tmp0_safe_receiver);
        var existing = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().p2();
        var _iterator__ex2g4s = values.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (!existing.t2(element)) {
            destination.j2(element);
          }
        }
        this.p4p(name, destination);
      }
      c4q(name) {
        this.r4p_1.b5(name);
      }
      s4() {
        this.r4p_1.s4();
      }
      s4p(name) {
      }
      x4p(value) {
      }
    }
    initMetadataForClass($, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
    StringValuesBuilderImplClass = $;
  }
  return StringValuesBuilderImplClass;
}
function get(name) {
  var tmp0_safe_receiver = this.u4p(name);
  return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
}
function forEach(body) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.o4p().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var k = element.m3();
    // Inline function 'kotlin.collections.component2' call
    var v = element.n3();
    body(k, v);
  }
  return Unit_instance;
}
var StringValuesClass;
function StringValues() {
  if (StringValuesClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'StringValues');
    StringValuesClass = $;
  }
  return StringValuesClass;
}
function tableSizeFor($this, size) {
  var n = size - 1 | 0;
  n = n | (n >>> 1 | 0);
  n = n | (n >>> 2 | 0);
  n = n | (n >>> 4 | 0);
  n = n | (n >>> 8 | 0);
  n = n | (n >>> 16 | 0);
  return n < 4 ? 4 : n + 1 | 0;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function listForKey($this, name) {
  if ($this.g4q_1 === 0)
    return null;
  var hash = computeHash($this, name);
  var idx = $this.h4q_1[hash & ($this.h4q_1.length - 1 | 0)];
  while (idx >= 0) {
    if (equals($this.e4q_1[idx], name, $this.d4q_1)) {
      return $this.f4q_1[idx];
    }
    idx = $this.i4q_1[idx];
  }
  return null;
}
function computeHash($this, key) {
  var tmp;
  if ($this.d4q_1) {
    tmp = caseInsensitiveHashCode(Companion_instance, key);
  } else {
    tmp = getStringHashCode(key);
  }
  return tmp;
}
var StringValuesEntryClass;
function StringValuesEntry() {
  if (StringValuesEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.j4q_1 = key;
        this.k4q_1 = value;
      }
      m3() {
        return this.j4q_1;
      }
      n3() {
        return this.k4q_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals_0(other.m3(), this.j4q_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(other.n3(), this.k4q_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.j4q_1) ^ hashCode(this.k4q_1);
      }
      toString() {
        return this.j4q_1 + '=' + toString_0(this.k4q_1);
      }
    }
    initMetadataForClass($, 'StringValuesEntry', VOID, VOID, [Entry()]);
    StringValuesEntryClass = $;
  }
  return StringValuesEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var StringValuesImplClass;
function StringValuesImpl() {
  if (StringValuesImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, values) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        values = values === VOID ? emptyMap() : values;
        this.d4q_1 = caseInsensitiveName;
        if (values.n1()) {
          this.g4q_1 = 0;
          var tmp = this;
          // Inline function 'kotlin.emptyArray' call
          tmp.e4q_1 = [];
          var tmp_0 = this;
          // Inline function 'kotlin.emptyArray' call
          tmp_0.f4q_1 = [];
          this.h4q_1 = new Int32Array(0);
          this.i4q_1 = new Int32Array(0);
        } else if (!this.d4q_1) {
          this.g4q_1 = values.q2();
          var tmp_1 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size = this.g4q_1;
          var tmp_2 = Array(size);
          tmp_1.e4q_1 = isArray(tmp_2) ? tmp_2 : THROW_CCE();
          var tmp_3 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size_0 = this.g4q_1;
          var tmp_4 = Array(size_0);
          tmp_3.f4q_1 = isArray(tmp_4) ? tmp_4 : THROW_CCE();
          var tableSize = tableSizeFor(Companion_instance, this.g4q_1);
          var tmp_5 = this;
          var tmp_6 = 0;
          var tmp_7 = new Int32Array(tableSize);
          while (tmp_6 < tableSize) {
            tmp_7[tmp_6] = -1;
            tmp_6 = tmp_6 + 1 | 0;
          }
          tmp_5.h4q_1 = tmp_7;
          var tmp_8 = this;
          var tmp_9 = 0;
          var tmp_10 = this.g4q_1;
          var tmp_11 = new Int32Array(tmp_10);
          while (tmp_9 < tmp_10) {
            tmp_11[tmp_9] = -1;
            tmp_9 = tmp_9 + 1 | 0;
          }
          tmp_8.i4q_1 = tmp_11;
          var i = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = values.l3().p1();
          while (_iterator__ex2g4s.q1()) {
            var _destruct__k2r9zo = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.collections.component1' call
            var key = _destruct__k2r9zo.m3();
            // Inline function 'kotlin.collections.component2' call
            var value = _destruct__k2r9zo.n3();
            this.e4q_1[i] = key;
            var tmp_12 = i;
            // Inline function 'kotlin.collections.List' call
            // Inline function 'kotlin.collections.MutableList' call
            var size_1 = value.q2();
            var list = ArrayList().i2(size_1);
            // Inline function 'kotlin.repeat' call
            var inductionVariable = 0;
            if (inductionVariable < size_1)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp$ret$13 = value.r2(index);
                list.j2(tmp$ret$13);
              }
               while (inductionVariable < size_1);
            this.f4q_1[tmp_12] = list;
            var hash = computeHash(this, key);
            var bucket = hash & (tableSize - 1 | 0);
            this.i4q_1[i] = this.h4q_1[bucket];
            this.h4q_1[bucket] = i;
            i = i + 1 | 0;
          }
        } else {
          var deduped = caseInsensitiveMap();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = values.l3().p1();
          while (_iterator__ex2g4s_0.q1()) {
            var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.r1();
            // Inline function 'kotlin.collections.component1' call
            var key_0 = _destruct__k2r9zo_0.m3();
            // Inline function 'kotlin.collections.component2' call
            var value_0 = _destruct__k2r9zo_0.n3();
            var existing = deduped.x4(key_0);
            if (!(existing == null)) {
              // Inline function 'kotlin.collections.set' call
              var value_1 = plus(existing, value_0);
              deduped.a5(key_0, value_1);
            } else {
              // Inline function 'kotlin.collections.set' call
              deduped.a5(key_0, value_0);
            }
          }
          this.g4q_1 = deduped.q2();
          var tmp_13 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size_2 = this.g4q_1;
          var tmp_14 = Array(size_2);
          tmp_13.e4q_1 = isArray(tmp_14) ? tmp_14 : THROW_CCE();
          var tmp_15 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          var size_3 = this.g4q_1;
          var tmp_16 = Array(size_3);
          tmp_15.f4q_1 = isArray(tmp_16) ? tmp_16 : THROW_CCE();
          var tableSize_0 = tableSizeFor(Companion_instance, this.g4q_1);
          var tmp_17 = this;
          var tmp_18 = 0;
          var tmp_19 = new Int32Array(tableSize_0);
          while (tmp_18 < tableSize_0) {
            tmp_19[tmp_18] = -1;
            tmp_18 = tmp_18 + 1 | 0;
          }
          tmp_17.h4q_1 = tmp_19;
          var tmp_20 = this;
          var tmp_21 = 0;
          var tmp_22 = this.g4q_1;
          var tmp_23 = new Int32Array(tmp_22);
          while (tmp_21 < tmp_22) {
            tmp_23[tmp_21] = -1;
            tmp_21 = tmp_21 + 1 | 0;
          }
          tmp_20.i4q_1 = tmp_23;
          var i_0 = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_1 = deduped.l3().p1();
          while (_iterator__ex2g4s_1.q1()) {
            var _destruct__k2r9zo_1 = _iterator__ex2g4s_1.r1();
            // Inline function 'kotlin.collections.component1' call
            var key_1 = _destruct__k2r9zo_1.m3();
            // Inline function 'kotlin.collections.component2' call
            var value_2 = _destruct__k2r9zo_1.n3();
            this.e4q_1[i_0] = key_1;
            var tmp_24 = i_0;
            // Inline function 'kotlin.collections.List' call
            // Inline function 'kotlin.collections.MutableList' call
            var size_4 = value_2.q2();
            var list_0 = ArrayList().i2(size_4);
            // Inline function 'kotlin.repeat' call
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < size_4)
              do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp$ret$30 = value_2.r2(index_0);
                list_0.j2(tmp$ret$30);
              }
               while (inductionVariable_0 < size_4);
            this.f4q_1[tmp_24] = list_0;
            var hash_0 = computeHash(this, key_1);
            var bucket_0 = hash_0 & (tableSize_0 - 1 | 0);
            this.i4q_1[i_0] = this.h4q_1[bucket_0];
            this.h4q_1[bucket_0] = i_0;
            i_0 = i_0 + 1 | 0;
          }
        }
      }
      t4p() {
        return this.d4q_1;
      }
      d2o(name) {
        var tmp0_safe_receiver = listForKey(this, name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      }
      u4p(name) {
        return listForKey(this, name);
      }
      v4p() {
        if (this.g4q_1 === 0)
          return emptySet();
        // Inline function 'kotlin.collections.linkedSetOf' call
        var result = LinkedHashSet().s2();
        var inductionVariable = 0;
        var last = this.g4q_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            result.j2(this.e4q_1[i]);
          }
           while (inductionVariable < last);
        return result;
      }
      n1() {
        return this.g4q_1 === 0;
      }
      o4p() {
        if (this.g4q_1 === 0)
          return emptySet();
        // Inline function 'kotlin.collections.linkedSetOf' call
        var result = LinkedHashSet().s2();
        var inductionVariable = 0;
        var last = this.g4q_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            result.j2(new (StringValuesEntry())(this.e4q_1[i], this.f4q_1[i]));
          }
           while (inductionVariable < last);
        return result;
      }
      a4q(body) {
        var inductionVariable = 0;
        var last = this.g4q_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            body(this.e4q_1[i], this.f4q_1[i]);
          }
           while (inductionVariable < last);
      }
      toString() {
        return 'StringValues(case=' + !this.d4q_1 + ') ' + toString_0(this.o4p());
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(!(other == null) ? isInterface(other, StringValues()) : false))
          return false;
        if (!(this.d4q_1 === other.t4p()))
          return false;
        return entriesEquals(this.o4p(), other.o4p());
      }
      hashCode() {
        return entriesHashCode(this.o4p(), imul(31, getBooleanHashCode(this.d4q_1)));
      }
    }
    initMetadataForClass($, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues()]);
    StringValuesImplClass = $;
  }
  return StringValuesImplClass;
}
var StringValuesSingleImpl$entries$1Class;
function StringValuesSingleImpl$entries$1() {
  if (StringValuesSingleImpl$entries$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.l4q_1 = this$0.o4q_1;
        this.m4q_1 = this$0.p4q_1;
      }
      m3() {
        return this.l4q_1;
      }
      n3() {
        return this.m4q_1;
      }
      toString() {
        return this.l4q_1 + '=' + toString_0(this.m4q_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals_0(other.m3(), this.l4q_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(other.n3(), this.m4q_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.l4q_1) ^ hashCode(this.m4q_1);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Entry()]);
    StringValuesSingleImpl$entries$1Class = $;
  }
  return StringValuesSingleImpl$entries$1Class;
}
var StringValuesSingleImplClass;
function StringValuesSingleImpl() {
  if (StringValuesSingleImplClass === VOID) {
    class $ {
      constructor(caseInsensitiveName, name, values) {
        this.n4q_1 = caseInsensitiveName;
        this.o4q_1 = name;
        this.p4q_1 = values;
      }
      t4p() {
        return this.n4q_1;
      }
      u4p(name) {
        return equals(this.o4q_1, name, this.t4p()) ? this.p4q_1 : null;
      }
      o4p() {
        return setOf(new (StringValuesSingleImpl$entries$1())(this));
      }
      n1() {
        return false;
      }
      v4p() {
        return setOf(this.o4q_1);
      }
      toString() {
        return 'StringValues(case=' + !this.t4p() + ') ' + toString_0(this.o4p());
      }
      hashCode() {
        return entriesHashCode(this.o4p(), imul(31, getBooleanHashCode(this.t4p())));
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(!(other == null) ? isInterface(other, StringValues()) : false))
          return false;
        if (!(this.t4p() === other.t4p()))
          return false;
        return entriesEquals(this.o4p(), other.o4p());
      }
      a4q(body) {
        return body(this.o4q_1, this.p4q_1);
      }
      d2o(name) {
        return equals(name, this.o4q_1, this.t4p()) ? firstOrNull(this.p4q_1) : null;
      }
    }
    initMetadataForClass($, 'StringValuesSingleImpl', VOID, VOID, [StringValues()]);
    StringValuesSingleImplClass = $;
  }
  return StringValuesSingleImplClass;
}
function entriesEquals(a, b) {
  return equals_0(a, b);
}
function entriesHashCode(entries, seed) {
  return imul(seed, 31) + hashCode(entries) | 0;
}
function flattenEntries(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = _this__u8e3s4.o4p();
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.map' call
    var this_0 = element.n3();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().i2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s_0 = this_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$5 = to(element.m3(), item);
      destination_0.j2(tmp$ret$5);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return destination;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  forEach as forEachghjt92rkrpzo,
  get as get3oezx9z3zutmm,
  StringValuesBuilderImpl as StringValuesBuilderImpl3ey9etj3bwnqf,
  StringValuesImpl as StringValuesImpl2l95y9du7b61t,
  StringValuesSingleImpl as StringValuesSingleImpl1uh7q2c2zm7va,
  StringValues as StringValuesjqid5a6cuday,
  appendAll as appendAlltwnjnu28pmtx,
  flattenEntries as flattenEntries2zw7fl55k6a0l,
};
//endregion

//# sourceMappingURL=StringValues.mjs.map
